import * as React from "react";
import { cn } from "../lib/utils";

export interface LoaderProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  /** Accessible name. The kit has no translations of its own, so the default is
   *  English; pass the page's own word. An explicit `aria-label` still wins. */
  label?: string;
}

const sizeClasses = {
  sm: "size-4",
  md: "size-8",
  lg: "size-12",
  xl: "size-16",
} as const;

/**
 * Loader - a plain shadcn-style spinner (lucide `Loader2` arc + `animate-spin`).
 * The colour comes from `currentColor`, so the same indicator fits a light/dark
 * background as well as inside a brand-gradient button (see `Button loading`).
 */
export function Loader({ className, size = "md", label = "Loading", ...props }: LoaderProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("shrink-0 animate-spin", sizeClasses[size], className)}
      role="status"
      aria-label={label}
      {...props}
    >
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  );
}
